// extracted by mini-css-extract-plugin
export var btn = "button-module--btn--8ayRj";
export var icon = "button-module--icon--VQNSW";
export var link = "button-module--link--uaPOf";
export var primary = "button-module--primary--M7S-H";
export var secondary = "button-module--secondary--2ogpO";